import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { INVOICE_STATUS } from "../../../constants";

export function InvoiceStatusFilter() {
  const { getParamsAsArray, setParam } = useQueryParams();
  const { t } = useTranslation();
  const paramKey = "status";

  return (
    <Picker
      showActionBar
      selectedKeys={getParamsAsArray(paramKey)}
      onSelectionChange={(keys) => {
        setParam(paramKey, Array.from(keys).map(String), true);
      }}
      label={t("Status")}
      items={[
        {
          id: INVOICE_STATUS.open,
          name: t("Open"),
        },
        {
          id: INVOICE_STATUS.voided,
          name: t("Voided"),
        },
        {
          id: INVOICE_STATUS.paid,
          name: t("Paid"),
        },
      ]}
      selectionMode="multiple"
      testID="status-filter"
    />
  );
}
